import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation} from '../Univ.js'
function IpPatPrint(props) {
    const [appData, setAppData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const {ip_id} = useParams();
    useEffect(() => {
        try {
            axios.get(`${baseUrl}edit-ip-admit/${ip_id}/`).then(function (response) {
                setAppData([response.data]);
            });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: "black", backgroundColor: "#e5eaef"}}>
                <i className="fa-solid fa-qrcode" aria-hidden="true" style={{color: "black"}}></i> ADMISSION FORM
            </h3>
            <div className="row nurseInpatient">
                <div className="col-md-12" id="invoice-print">
                    <div className="table-responsive">
                        <table width="100%" style={{
                            border: "1px solid",
                            borderColor: "#2194d9",
                            fontWeight: "bold",
                            paddingLeft: "18px"
                        }}>
                            <tbody>
                            <tr>
                                {hospData.map((hospital) => (
                                    <td colspan="2" align="right">
                                        <p align="center">
                                            <strong>{hospital.hospital}</strong><br/>
                                            <br></br>Address&nbsp;: &nbsp;{hospital.address}
                                        </p>
                                    </td>
                                ))}
                            </tr>
                            {appData.map((app) => (
                                <>
                                    <tr align="center">
                                        <td style={{fontWeight: "bold", paddingLeft: "108px"}}>
                                            Admitted On: {new Date(app.admit_date).toLocaleDateString()}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>UHID : <b>{app.pat.pat_id}</b></td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Name : {app.pat.patient},
                                        </td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>IP ID : {app.ip_id}</td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Ward No : {app.room_no.room.room}/{app.room_no.room_no}</td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Age : {app.pat.age}/{app.pat.gender}</td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Mobile : {app.pat.mobile}</td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }} colSpan="2">Address : <b>{app.pat.address1}</b></td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>MLC : <b>{app.mlc}</b></td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Referred. : <b>{app.refered}</b></td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Consultant
                                            : <b>{app.primary_consult.my_title}{app.primary_consult.consultant} - {app.primary_consult.specialization}</b>
                                        </td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Payment Type : <b>{app.payment}</b></td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Attender : <b>{app.relname}</b></td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Att. Relation : <b>{app.reltype}</b></td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Staff Sign :
                                        </td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}></td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}>Consultant Sign :
                                        </td>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9",
                                            fontWeight: "bold",
                                            paddingLeft: "18px"
                                        }}></td>
                                    </tr>
                                </>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                >
                    Print
                </button>
            </div>
        </section>
    )
}
export default IpPatPrint;
